<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <div style="height: auto;width: 100%;" class="cargo-advance-search share-search">
        <div ref="searchOperations" style="margin-top: 10px; margin-bottom: 10px;" class="cargo-advance-search-operations">
          <div style="display: inline-block; margin-right: 5px">
            <span>{{ $t('Pricing.ShareState') }}</span>
            <el-select
              v-model="shareState"
              no="shareState"
            >
              <el-option
                v-for="(item,index) in shareStates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <el-button no="onQuery" type="primary" @click="onQuery()">{{ $t('Pricing.Query') }}</el-button>
          <el-button v-show="isActiveCpTab" no="onAddShare" type="primary" @click="onAddShare()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="isActiveCpTab" no="onEdit" type="primary" :disabled="!cpSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="!isActiveCpTab" no="onAcceptShare" type="primary" :disabled="!(ppSelectRow != null && !ppSelectRow.active && !ppSelectRow.applyFor)" @click="onAcceptShare()">{{ $t('Pricing.Accept') }}</el-button>
          <el-button v-show="isActiveCpTab" no="onAgree" :disabled="!(cpSelectRow != null && cpSelectRow.applyFor && (cpSelectRow.checkState === 0 || cpSelectRow.checkState === 3))" type="primary" @click="onAgree()">{{ $t('Pricing.Agree') }}</el-button>
          <el-button v-show="isActiveCpTab" no="onRefuse" :disabled="!(cpSelectRow != null && cpSelectRow.applyFor && (cpSelectRow.checkState === 0 || cpSelectRow.checkState === 3))" type="primary" @click="onRefuse()">{{ $t('Pricing.Refuse') }}</el-button>
          <el-button v-show="isActiveCpTab" no="onCancel" :disabled="!(cpSelectRow != null && cpSelectRow.applyFor && cpSelectRow.checkState === 1)" type="primary" @click="cancleAgree()">{{ $t('Pricing.CancelAgree') }}</el-button>
        </div>
      </div>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.AuthInvite2')" name="cpList">
          <div class="grid-view">
            <div class="main-content">
              <div class="section grid-wrapper">
                <cargo-ag-grid
                  :v-if="activeTabName === 'cpList'"
                  config-module="221601"
                  :show-approve="true"
                  :row-data="rowCpData"
                  :grid-options="cpGridOptions"
                  :column-defs="inviteColumnDefs"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.AuthAccept2')" name="ppList">
          <cargo-ag-grid
            :v-if="activeTabName === 'ppList'"
            config-module="221602"
            :show-approve="false"
            :show-selection="true"
            :row-data="rowPpData"
            :grid-options="ppGridOptions"
            :column-defs="acceptColumnDefs"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="formDialog.visible"
      :title="$t('Price.FullContainerFreightSharingDetails')"
      width="400px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="5vh"
      custom-class="details-view fcl-addon-form"
    >
      <div class="main-content">
        <div style="margin-bottom: 10px">
          <el-button no="onSave" type="primary" @click="onSave">{{ $t('Pricing.Save') }}</el-button>
          <el-button no="cancel" @click="formDialog.visible=false">{{ $t('Pricing.Cancel') }}</el-button>
        </div>
        <div style="width: fit-content">
          <div style="display: flex">
            <div class="section form-column" style="width: 380px !important;">
              <el-form
                label-width="120px"
                label-position="left"
              >
                <el-form-item :label="$t('Pricing.IWantShare')">
                  <cargo-advance-select
                    no="acceptTenant"
                    :disabled="!formDialog.isShareTo"
                    :select-type="selectTypeNames.TENANT"
                    :cache="false"
                    filterable
                    :custom-label="(item)=>`[${item.id}]${item.name}`"
                    callback-method-type="obj"
                    :default-value="String(formDialog.tenantShare.acceptTenant)||''"
                    @parentCallBack="changeTenant"
                  />
                </el-form-item>
                <el-form-item v-show="needMarkup" :label="$t('Pricing.AllowedTier')">
                  <el-select
                    v-model="formDialog.tenantShare.point"
                    no="point"
                  >
                    <el-option
                      v-for="(item,index) in tiers"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-if="priceSharing === 'PriceFclSharing'" :label="$t('Pricing.SharingProfile')">
                  <div style="display:flex;">
                    <el-input v-model="formDialog.tenantSharingPriceProfileName" no="tenantSharingPriceProfileName" disabled />
                    <el-button no="showProfile" @click="showProfile(false)">{{ $t('Pricing.SelectProfile') }}</el-button>
                    <el-button v-if="this.tenantSharingPriceProfileDialog.isEdit" no="resetProfile" @click="resetProfile">{{ $t('SeaExport.Reset') }}</el-button>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Pricing.ShareRemark')">
                  <span slot="label">
                    <span style="width:100%; display: inline-block;">
                      {{ $t('Pricing.ShareRemark') }}
                    </span>
                    <span style="color: #ff0000">
                      {{ $t('Pricing.ShareRemarks') }}
                    </span>
                  </span>
                  <el-input
                    v-model="formDialog.tenantShare.remarks"
                    no="remarks"
                    type="textarea"
                    :maxlength="255"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="applyDialog.visible"
      :close-on-click-modal="false"
      :title="applyDialog.isAccept ? $t('Pricing.Agree') : $t('Pricing.Refuse')"
      width="400px"
      top="5vh"
      custom-class="details-view fcl-addon-form"
    >
      <div class="main-content">
        <div style="width: fit-content">
          <div style="display: flex">
            <div class="section form-column" style="width: 380px !important;">
              <el-form
                label-width="120px"
                label-position="left"
              >
                <el-form-item :label="$t('Pricing.WantApply')">
                  <el-input
                    no="wantApply"
                    :value="applyDialog.tenantShare.acceptTenant + ' ' + applyDialog.tenantShare.acceptTenantName"
                    disabled
                  />
                </el-form-item>
                <el-form-item v-show="applyDialog.isAccept" :label="$t('Pricing.AllowedTier')">
                  <el-select
                    v-model="applyDialog.tenantShare.point"
                    no="allowedTier"
                  >
                    <el-option
                      v-for="(item,index) in tiers"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-if="priceSharing === 'PriceFclSharing' && applyDialog.isAccept" :label="$t('Pricing.SharingProfile')">
                  <div style="display:flex;">
                    <el-input v-model="applyDialog.tenantSharingPriceProfileName" no="tenantSharingPriceProfileName" disabled />
                    <el-button no="selectProfile" @click="showProfile(true)">{{ $t('Pricing.SelectProfile') }}</el-button>
                    <el-button no="reset" @click="resetProfile">{{ $t('SeaExport.Reset') }}</el-button>
                  </div>
                </el-form-item>
                <el-form-item v-show="applyDialog.isAccept" :label="$t('Pricing.ShareRemark')">
                  <span slot="label">
                    <span style="width:100%; display: inline-block;">
                      {{ $t('Pricing.ShareRemark') }}
                    </span>
                    <span style="color: #ff0000">
                      {{ $t('Pricing.ShareRemarks') }}
                    </span>
                  </span>
                  <el-input
                    v-model="formDialog.tenantShare.remarks"
                    no="tenantShareRemarks"
                    type="textarea"
                    :maxlength="255"
                  />
                </el-form-item>
                <el-form-item v-show="!applyDialog.isAccept" :label="$t('Pricing.RefuseRemark')">
                  <el-input
                    v-model="applyDialog.tenantShare.remarks"
                    no="applyDialogRemarks"
                    type="textarea"
                    :maxlength="255"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button no="commitHandler" type="primary" @click="commitHandler">{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button no="applyDialogClose" @click="applyDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--策略-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="tenantSharingPriceProfileDialog.visible"
      :title="$t('Pricing.PriceProfile')"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-params.sync="tenantSharingPriceProfileDialog.gridParams"
        :grid-options="tenantSharingPriceProfileDialog.gridOptions"
        :column-defs="tenantSharingPriceProfileDialog.columnDefs"
        :row-data="tenantSharingPriceProfileDialog.rowData"
        :auto-fit-content="false"
        style="width: 100%;min-height: 150px;margin-top: 20px;"
      />
      <span slot="footer">
        <el-button v-show="tenantSharingPriceProfileDialog.isEdit" no="profileDialogConfirm" @click="confirmProfile">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="profileDialogClose" @click="tenantSharingPriceProfileDialog.visible= false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import URL from '@/api/urlTranslator'
import FclAddonForm from '@/views/cargo/v0/Price/PriceFclAddon/components/fclAddonForm'
import ColumnUtils from '@/utils/ColumnUtils'
import { PricingAirConfigUtil } from '@/class/cargo/model/utils/PricingAirConfigUtil'
import { PricingLCLConfigUtil } from '@/class/cargo/model/utils/PricingLCLConfigUtil'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { accept, getTenantSharings, saveMe, updateCheckState, updatePoint, getTenantSharingPriceProfile, cancelAgree } from '@/api/price/tenantSharing'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { deepClone } from '@/utils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
import OperationRender from '@/components/OperationRender/index'
import { getObjectByCache } from '@/utils/basicDataCache'

export default {
  name: 'ShareList',
  components: {
    CargoAdvanceSelect,
    FclAddonForm,
    OperationRender
  },
  props: {
    priceSharing: { type: String, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      isAdminOrHQ: false,
      remarkChange: '',
      targetLevel: 99,
      txtCpRemarks: '',
      txtPpRemarks: '',
      activeTabName: 'cpList',
      showDetail: false,
      cpSelectRow: {}, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      rowCpData: [],
      rowPpData: [],
      fullscreenLoading: null,
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onGridRowClickedEvent
      },
      fclAddonFormDialog: {
        visible: false,
        ss: {},
        isNew: false
      },
      priceFclUtil: null,
      pgsLMap: {},
      shareState: '0',
      shareStates: [
        {
          label: this.$t('Pricing.AllState'),
          value: '0'
        },
        {
          label: this.$t('Pricing.Accepted'),
          value: '1'
        },
        {
          label: this.$t('Pricing.NotAccepted'),
          value: '2'
        },
        {
          label: this.$t('Pricing.NotCheck'),
          value: '3'
        },
        {
          label: this.$t('Pricing.Agreed'),
          value: '4'
        },
        {
          label: this.$t('Pricing.Refused'),
          value: '5'
        }],
      acceptColumnDefs: [
        { headerName: this.$t('Pricing.ShareState'), field: 'isActive', colId: 'isActive', flex: 1,
          valueFormatter: (params) => {
            return this.activeColumnLabelFunc2(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.InviteTenant2'), field: 'inviteTenantName', colId: 'inviteTenantName', flex: 1
        },
        {
          headerName: this.$t('Pricing.InviteUser2'), field: 'inviteUserName', colId: 'inviteUserName', flex: 1
        },
        {
          headerName: this.$t('Pricing.inviteTime2'), field: 'inviteTime', colId: 'inviteTime', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.AcceptUser2'), field: 'acceptUserName', colId: 'acceptUserName', flex: 1
        },
        {
          headerName: this.$t('Pricing.AcceptTime2'), field: 'acceptTime', colId: 'acceptTime', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ShareRemark'), field: 'remarks', colId: 'remarks', flex: 1
        }
      ],
      needMarkup: false,
      tiers: PriceUtils.TIERS,
      formDialog: {
        visible: false,
        isValid: false,
        isShareTo: false,
        tenantShare: {},
        tenantSharingPriceProfile: [], // 运价分享策略
        tenantSharingPriceProfileName: '' // 分享策略名称
      },
      applyDialog: {
        visible: false,
        isAccept: true,
        tenantShare: {},
        tenantSharingPriceProfileName: ''
      },
      tenantSharingPriceProfileDialog: {
        visible: false,
        isEdit: false,
        gridParams: {},
        gridApi: null,
        columnDefs: [
          { headerName: this.$t('Pricing.Name'), field: 'name', colId: 'name' },
          { headerName: this.$t('Pricing.MatchType'), field: 'matchType', colId: 'matchType',
            valueFormatter: (params) => {
              return this.matchTypeLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.PriceType'), field: 'application', colId: 'application',
            valueFormatter: (params) => {
              return this.applicationLabFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.POL'), field: 'polExpression', colId: 'polExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'polExpression')
            }
          },
          { headerName: this.$t('Pricing.PolCountry'), field: 'polRegionExpression', colId: 'polRegionExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'polRegionExpression')
            }
          },
          { headerName: this.$t('Pricing.PolRegion'), field: 'polCountryExpression', colId: 'polCountryExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'polCountryExpression')
            }
          },
          { headerName: this.$t('Pricing.POD'), field: 'podExpression', colId: 'podExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'podExpression')
            }
          },
          { headerName: this.$t('Pricing.PodCountry'), field: 'podRegionExpression', colId: 'podRegionExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'podRegionExpression')
            }
          },
          { headerName: this.$t('Pricing.PodRegion'), field: 'podCountryExpression', colId: 'podCountryExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'podRegionExpression')
            }
          },
          { headerName: this.$t('Pricing.Carrier'), field: 'carrierExpression', colId: 'carrierExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'carrierExpression')
            }
          },
          { headerName: this.$t('Pricing.Lane'), field: 'laneExpression', colId: 'laneExpression',
            valueFormatter: (params) => {
              return this.convertNull(params.value, 'laneExpression')
            }
          }
        ],
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 0,
          onRowDataChanged: event => {
            this.tenantSharingPriceProfileDialog.selectedNode = null
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.tenantSharingPriceProfileDialog.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            // 重置单选行
            if (this.tenantSharingPriceProfileDialog.selectedNode) {
              const rowIndex = this.tenantSharingPriceProfileDialog.selectedNode.rowIndex
              this.tenantSharingPriceProfileDialog.selectedNode = null
              event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          context: {
            componentParent: this
          }
        },
        selectedNode: null,
        priceSharingProfileChanged: false,
        isAgreeOrRefuse: false // 同意申请/拒绝申请
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    },
    inviteColumnDefs() {
      const rowData = [
        { headerName: this.$t('Pricing.ShareState'), field: 'isActive', colId: 'isActive', flex: 1,
          valueFormatter: (params) => {
            return this.activeColumnLabelFunc2(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.AcceptTenant2'), field: 'acceptTenantName', colId: 'acceptTenantName', flex: 1
        },
        {
          headerName: this.$t('Pricing.AcceptUser2'), field: 'acceptUserName', colId: 'acceptUserName', flex: 1
        },
        {
          headerName: this.$t('Pricing.AcceptTime2'), field: 'acceptTime', colId: 'acceptTime', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Level'), field: 'point', colId: 'point', flex: 1,
          valueFormatter: (params) => {
            return this.tierLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.InviteUser2'), field: 'inviteUserName', colId: 'inviteUserName', flex: 1
        },
        {
          headerName: this.$t('Pricing.inviteTime2'), field: 'inviteTime', colId: 'inviteTime', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ShareRemark'), field: 'remarks', colId: 'remarks', flex: 1
        }
      ]
      if (this.priceSharing === 'PriceFclSharing') {
        rowData.push({
          headerName: this.$t('Pricing.SharingProfile'),
          field: '',
          colId: '',
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Pricing.ViewProfile'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.showSharingProfileForGrid(params)
                },
                visible: (params) => { return true }
              }
            ]
          }
        })
      }
      return rowData
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      switch (this.priceSharing) {
        case 'PriceFclSharing':
          this.needMarkup = (await PricingFCLConfigUtil.getInstance()).needMarkup
          break
        case 'PriceLclSharing':
          this.needMarkup = (await PricingLCLConfigUtil.getInstance()).needMarkup
          break
        case 'PriceAirSharing':
          this.needMarkup = (await PricingAirConfigUtil.getInstance()).needMarkup
          break
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    onQuery() {
      this.fullscreenLoading = getLoading()
      const params = {
        category: this.priceSharing,
        state: this.shareState,
        isInvite: this.isActiveCpTab
      }
      getTenantSharings(params).then((res) => {
        this.loadingEnd()
        const rowData = res.data
        if (rowData && rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
        this.setRowData(rowData)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    setRowData(result) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
      } else {
        this.rowPpData = result
      }
    },
    onGridRowClickedEvent(e) {
      const data = e.data
      if (this.isActiveCpTab) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      this.cpSelectRow = null
      this.ppSelectRow = null
      this.fullscreenLoading.close()
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.cpSelectRow = data
      this.onEdit()
    },
    async onEdit() {
      this.formDialog.visible = true
      this.formDialog.isShareTo = true
      this.formDialog.tenantShare = deepClone(this.cpSelectRow)
      if (this.priceSharing === 'PriceFclSharing') {
        await this.loadTenantSharingPriceProfile()
        this.formDialog.tenantSharingPriceProfileName = ''
        this.formDialog.priceSharingProfileUuid = ''
        this.tenantSharingPriceProfileDialog.isEdit = true
        if (this.formDialog.tenantSharingPriceProfile && this.formDialog.tenantSharingPriceProfile.length > 0) {
          if (this.formDialog.tenantShare && this.formDialog.tenantShare.uuid) {
            for (const item of this.formDialog.tenantSharingPriceProfile) {
              if (this.formDialog.tenantShare.uuid === item.tenantSharingUuid) {
                this.formDialog.tenantSharingPriceProfileName = item.name
                this.formDialog.tenantShare.priceSharingProfileUuid = item.profileUuid
                break
              }
            }
          }
        }
      }
    },
    onAddShare() {
      this.formDialog.visible = true
      this.formDialog.isShareTo = true
      this.formDialog.tenantSharingPriceProfileName = ''
      this.formDialog.tenantShare = {
        acceptTenant: 0,
        remarks: '',
        point: '0',
        priceSharingProfileUuid: ''
      }
      this.loadTenantSharingPriceProfile()
    },
    async onSave() {
      const tenantShare = this.formDialog.tenantShare
      if (!tenantShare.uuid) {
        if (tenantShare.acceptTenant === 0) {
          this.$message.warning(this.$t('Pricing.ShareToPrompt'))
          return
        }
        const message = StrUtils.substitute(this.$t('Pricing.ReallyWantShare'), tenantShare.acceptTenantName)
        this.saveConfirm(message)
      } else {
        if (tenantShare.point === this.cpSelectRow.point && !this.priceSharingProfileChanged) {
          this.$message.warning(this.$t('Pricing.NoTierChange'))
          return
        } else {
          const levelLabel = PriceUtils.levelLabel(tenantShare.point)
          const message = StrUtils.substitute(this.$t('Pricing.ReallyWantChange'), levelLabel)
          this.saveConfirm(message)
        }
      }
    },
    saveConfirm(message) {
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const tenantShare = this.formDialog.tenantShare
        if (!tenantShare.uuid) {
          switch (this.priceSharing) {
            case '':
              tenantShare.name = '整箱(FCL)运价'
              break
            case 'PriceLclSharing':
              tenantShare.name = '拼箱(LCL)运价'
              break
            case 'PriceAirSharing':
              tenantShare.name = '空运(AIR)运价'
              break
          }
          tenantShare.category = this.priceSharing
          this.fullscreenLoading = getLoading()
          saveMe(tenantShare).then(res => {
            const share = res.data
            this.rowCpData.push(share)
            this.formDialog.visible = false
            this.loadingEnd()
          }).catch(() => {
            this.loadingEnd
          })
        } else {
          this.fullscreenLoading = getLoading()
          updatePoint(tenantShare).then(res => {
            this.formDialog.visible = false
            this.loadingEnd()
            this.onQuery()
          }).catch(() => {
            this.loadingEnd
          })
        }
      })
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const api = this.getGridOptionsApi()
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    activeColumnLabelFunc2(data) {
      if (data.applyFor) {
        switch (data.checkState) {
          case 0:
            return this.$t('Pricing.NotCheck') // 待审核
          case 1:
            return this.$t('Pricing.Agreed') // 同意
          case 2:
            return this.$t('Pricing.Refused') // 拒绝
          case 3:
            return this.$t('Pricing.Canceled') // 撤销
        }
      } else {
        if (data.active) {
          return this.$t('Pricing.Accepted')
        }
        return this.$t('Pricing.NotAccepted')
      }
      return ''
    },
    tierLabelFunc(value) {
      if (!value) return ''
      switch (value) {
        case '0':
          return 'Cost'
        case '1':
          return 'Tier 1'
        case '2':
          return 'Tier 2'
        case '99':
          return 'Tier 3'
        default:
          return ''
      }
    },
    changeTenant(p) {
      this.formDialog.tenantShare.acceptTenant = p.value
      this.formDialog.tenantShare['acceptTenantName'] = p.name
    },
    onAcceptShare() {
      const message = StrUtils.substitute(this.$t('Pricing.ReallyWantAccept'), this.ppSelectRow.inviteTenantName)
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.ppSelectRow.applyFor = false
        this.fullscreenLoading = getLoading()
        accept(this.ppSelectRow).then(res => {
          this.$message.success(this.$t('Pricing.SavedSucceed'))
          this.loadingEnd()
          this.onQuery()
        })
      })
    },
    onAgree() {
      this.applyDialog.visible = true
      this.applyDialog.isAccept = true
      this.applyDialog.tenantShare = deepClone(this.cpSelectRow)
    },
    onRefuse() {
      this.applyDialog.visible = true
      this.applyDialog.isAccept = false
      this.applyDialog.tenantShare = deepClone(this.cpSelectRow)
    },
    commitHandler() {
      this.fullscreenLoading = getLoading()
      const tenantShare = this.applyDialog.tenantShare
      if (this.applyDialog.isAccept) {
        tenantShare.checkState = 1
        tenantShare.isActive = true
      } else {
        // 1:同意; 2:拒绝
        tenantShare.checkState = 2
        tenantShare.isActive = false
      }
      updateCheckState(tenantShare).then(res => {
        const result = res.data
        this.applyDialog.visible = false
        if (result.applyFor) {
          // 1:同意; 2:拒绝
          if (result.checkState === 1) {
            this.$message.success(this.$t('Pricing.ApplyAgree'))
          } else if (result.checkState === 2) {
            this.$message.success(this.$t('Pricing.ApplyRefuse'))
          } else {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          }
        }
        this.loadingEnd()
        this.onQuery()
      })
    },
    cancleAgree() {
      this.fullscreenLoading = getLoading()
      const tenantShare = deepClone(this.cpSelectRow)
      tenantShare.checkState = 3
      tenantShare.isActive = false
      cancelAgree(tenantShare).then(res => {
        const result = res.data
        if (result.applyFor) {
          this.$message.success(this.$t('Pricing.CancelAgreed'))
        }
        this.loadingEnd()
        this.onQuery()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 加载当前租户所有的分享运价策略
    async loadTenantSharingPriceProfile() {
      await getTenantSharingPriceProfile().then(res => {
        if (res.data && res.data.length > 0) {
          this.formDialog.tenantSharingPriceProfile = res.data
        } else {
          this.formDialog.tenantSharingPriceProfile = []
        }
      })
    },
    async showProfile(isAgreeOrRefuse = false) {
      this.tenantSharingPriceProfileDialog.isAgreeOrRefuse = isAgreeOrRefuse
      this.tenantSharingPriceProfileDialog.isEdit = true
      if (!isAgreeOrRefuse) {
        this.tenantSharingPriceProfileDialog.rowData = this.formDialog.tenantSharingPriceProfile
        if (this.tenantSharingPriceProfileDialog.gridApi) {
          if (this.formDialog.priceSharingProfileUuid && this.formDialog.tenantSharingPriceProfile) {
            const index = this.formDialog.tenantSharingPriceProfile.findIndex(p => p.profileUuid === this.formDialog.priceSharingProfileUuid)
            const selectedNode = this.tenantSharingPriceProfileDialog.gridApi.getModel().rowsToDisplay[index]
            selectedNode.setSelected(true)
          }
        }
      } else {
        await getTenantSharingPriceProfile().then(res => {
          if (res.data && res.data.length > 0) {
            this.tenantSharingPriceProfileDialog.rowData = res.data
          } else {
            this.tenantSharingPriceProfileDialog.rowData = []
          }
        })
        if (this.tenantSharingPriceProfileDialog.gridApi) {
          this.applyDialog.tenantSharingPriceProfileName = ''
          if (this.applyDialog.tenantShare.priceSharingProfileUuid && this.applyDialog.tenantShare.tenantSharingPriceProfile) {
            const index = this.tenantSharingPriceProfileDialog.rowData.findIndex(p => p.profileUuid === this.applyDialog.tenantShare.priceSharingProfileUuid)
            const selectedNode = this.tenantSharingPriceProfileDialog.gridApi.getModel().rowsToDisplay[index]
            selectedNode.setSelected(true)
          }
        }
      }
      this.priceSharingProfileChanged = false
      this.tenantSharingPriceProfileDialog.visible = true
    },
    resetProfile() {
      if (!this.tenantSharingPriceProfileDialog.isAgreeOrRefuse) {
        this.formDialog.tenantSharingPriceProfileName = ''
        this.formDialog.tenantShare.priceSharingProfileUuid = ''
      } else {
        this.applyDialog.tenantSharingPriceProfileName = ''
        this.applyDialog.tenantShare.priceSharingProfileUuid = ''
      }
    },
    confirmProfile() {
      if (!this.tenantSharingPriceProfileDialog.isAgreeOrRefuse) {
        if (this.tenantSharingPriceProfileDialog.selectedNode) {
          this.formDialog.tenantSharingPriceProfileName = this.tenantSharingPriceProfileDialog.selectedNode.data.name
          this.formDialog.tenantShare.priceSharingProfileUuid = this.tenantSharingPriceProfileDialog.selectedNode.data.profileUuid
        } else {
          this.formDialog.tenantSharingPriceProfileName = ''
          this.formDialog.tenantShare.priceSharingProfileUuid = ''
        }
      } else {
        if (this.tenantSharingPriceProfileDialog.selectedNode) {
          this.applyDialog.tenantSharingPriceProfileName = this.tenantSharingPriceProfileDialog.selectedNode.data.name
          this.applyDialog.tenantShare.priceSharingProfileUuid = this.tenantSharingPriceProfileDialog.selectedNode.data.profileUuid
        } else {
          this.applyDialog.tenantSharingPriceProfileName = ''
          this.applyDialog.tenantShare.priceSharingProfileUuid = ''
        }
      }
      if (this.tenantSharingPriceProfileDialog.isEdit) {
        this.priceSharingProfileChanged = true
      }
      this.tenantSharingPriceProfileDialog.visible = false
    },
    matchTypeLabelFunc(value) {
      const state = CommonState.getStateByCode(SystemConstants.MATCH_TYPES, value)
      if (state) {
        return state.chineseName
      }
      return ''
    },
    applicationLabFunc(value) {
      const state = CommonState.getStateByCode(SystemConstants.PRICE_APPLICATIONS, value)
      if (state) {
        return state.chineseName
      }
      return ''
    },
    convertNull(value, dataFiled) {
      if (value) {
        let text = ''
        const arr = value.split('|')
        if (arr && arr.length > 0) {
          if (dataFiled === 'polRegionExpression' || dataFiled === 'podRegionExpression') {
            for (const item of arr) {
              const region = getObjectByCache(TYPE_NAMES.basic_data_Region, 'code', item)
              if (region) {
                if (!text) {
                  text = region.name
                } else {
                  text = text + '|' + region.name
                }
              }
            }
          } else if (dataFiled === 'polCountryExpression' || dataFiled === 'podCountryExpression') {
            for (const item of arr) {
              const country = getObjectByCache(TYPE_NAMES.basic_data_Country, 'code', item)
              if (country) {
                if (!text) {
                  text = country.chineseName
                } else {
                  text = text + '|' + country.chineseName
                }
              }
            }
          } else if (dataFiled === 'carrierExpression') { // 船公司先匹配scac,匹配不到再匹配shortName
            const notFoundList = []
            for (const item of arr) { // 先匹配scac
              const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'scac', item)
              if (company) {
                if (!text) {
                  text = company.chineseName
                } else {
                  text = text + '|' + company.chineseName
                }
              } else {
                const index = notFoundList.findIndex(row => { return row === item })
                if (index < 0) {
                  notFoundList.push(index)
                }
              }
            }
            if (notFoundList && notFoundList.length > 0) {
              for (const shortName of notFoundList) {
                const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'shortName', shortName)
                if (company) {
                  if (!text) {
                    text = company.chineseName
                  } else {
                    text = text + '|' + company.chineseName
                  }
                }
              }
            }
          }
        }
        return text || value
      }
      return $store.getters.language === 'zh' ? '全部' : 'ALL'
    },
    async showSharingProfileForGrid(data) {
      this.tenantSharingPriceProfileDialog.isEdit = false
      if (data.priceSharingProfile) {
        this.tenantSharingPriceProfileDialog.rowData = [data.priceSharingProfile]
      } else {
        this.tenantSharingPriceProfileDialog.rowData = []
      }
      this.tenantSharingPriceProfileDialog.visible = true
    }
  }
}
</script>

<style scoped>

</style>
